import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import aside from '../Images/OrderThatAccountScreenWeb.svg';
import { CircularProgress } from '@mui/material';

const AuthPageLoader = () => (
  <div
    className="d-flex flex-column align-items-center justify-content-center"
    style={{ height: '100%', backgroundColor: '#f8f9fa' }}
  >
    <CircularProgress sx={{ color: '#ED1C25' }} />
  </div>
);

const AuthLayout = () => {
  return (
    <section className="overflow-hidden">
      <div className="container-fluid">
        <div className="row" style={{ minHeight: '100vh' }}>
          {/* Left side with SVG Image */}
          <div className="col-12 col-lg-6 px-0 py-0 m-0 position-relative auth-banner-container">
            <object
              data={aside}
              type="image/svg+xml"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center',
                margin: '0',
                overflow: 'hidden',
                pointerEvents: 'none',
              }}
            />
          </div>
          {/* Right side with nested route component */}
          <div className="col-12 col-lg-6 px-0 auth-form-wrapper">
            <Suspense fallback={<AuthPageLoader />}>
              <Outlet />
            </Suspense>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuthLayout;
